// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__CJdcK","current":"style_current__1vY_2","arrow":"style_arrow__22C_3"};